import styled from 'styled-components';
import { ProgressStepperStepMixin } from '../../mixins/components/ProgressStepperStepMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
import { UnstyledButton } from '../UnstyledButton/UnstyledButton';
export var StyledProgressStepperStep = /*#__PURE__*/styled(UnstyledButton).withConfig({
  shouldForwardProp: doNotForwardTransientProp(['orientation'])
}).withConfig({
  displayName: "StyledProgressStepperStep",
  componentId: "c11n-8-111-1__sc-mb634v-0"
})(["", ""], ProgressStepperStepMixin);